import { Tooltip, withStyles } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';

const TooltipCustom = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#37474F',
    color: '#fff',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '180%',
    letterSpacing: '2%',
    padding: '16px',
    borderRadius: '8px',
    maxWidth: '520px !important',
    textAlign: 'center',
  },
  popper: {
    top: '5px !important',
  },
  arrow: {
    color: '#37474F',
  },
}))(Tooltip);

const InfoComponent = ({
  title = 'Switch between users with mandatory skill paths and those without',
}) => {
  return (
    <TooltipCustom
      placement="top"
      arrow
      title={
        <div className="supportText" style={{ color: `#fff` }}>
          {title}
        </div>
      }
    >
      <InfoOutlined style={{ height: '18px', width: '18px', color: '#78909c' }} />
    </TooltipCustom>
  );
};

export default InfoComponent;
